export default __webpack_public_path__ + "static/media/about.df0a28f4.jpg";